<div class="impersonation-indicator">
  <div class="impersonation-background">
    <p>Impersonation Mode is On</p>
    <button
      type="button"
      class="ks-btn-sm ks-btn-outline-neutral"
      (click)="existImpersonationMode()"
    >
      Exit mode
    </button>
  </div>
</div>
